import { createContext, useContext } from 'react';
import { useSelectCore } from './useCoreSelect';
import { useFloating, useInteractions } from '@floating-ui/react';

type SelectIds = {
	label: string;
	input: string;
	listbox: string;
	trigger: string;
	error: string;
	option: (i: number) => string;
};

export type Ctx = ReturnType<typeof useSelectCore> & {
	ids: SelectIds;
	listRef: React.RefObject<Array<HTMLElement | null>>;
	refs: ReturnType<typeof useFloating>['refs'];
	floatingStyles: React.CSSProperties;
	getFloatingProps: ReturnType<typeof useInteractions>['getFloatingProps'];
	getReferenceProps: ReturnType<typeof useInteractions>['getReferenceProps'];
	getItemProps: ReturnType<typeof useInteractions>['getItemProps'];
	dontOpenDropdownIfNoOptions?: boolean;
	context: ReturnType<typeof useFloating>['context'];
	fieldRef: React.RefObject<HTMLDivElement | null>;
	pillsVariant: boolean;
	toggleItem: (val: string | number) => void;
	getItemChecked: (val: string | number) => boolean;
	toggleSelectAllGlobal: () => void;
	toggleSelectAllVisible: () => void;
	isAllActive: boolean;
	useAllSentinel: boolean;
};

export const SelectCtx = createContext<Ctx | null>(null);
export const useSelect = () => {
	const ctx = useContext(SelectCtx);
	if (!ctx) throw Error('Select.* must be used inside <Select.Root>');
	return ctx;
};
